// PRD-3255: talents without a live assignment (unassigned, or inactive after deactivation, which
// runs unassign first) get a read only Time-off view of their last assignment.
export const LAST_ASSIGNMENT_VIEW_STATUSES = ["unassigned", "inactive"];

export const isLastAssignmentView = (status?: string | null): boolean =>
  !!status && LAST_ASSIGNMENT_VIEW_STATUSES.includes(status);
